import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { ArrowDownIcon, ArrowUpIcon } from 'lucide-react';
import { AnalyticsMetric } from '../types';

interface MetricCardProps {
  metric: AnalyticsMetric;
  icon?: React.ReactNode;
}

export function MetricCard({ metric, icon }: MetricCardProps) {
  const { label, value, change, trend } = metric;
  
  const formatValue = (value: number): string => {
    if (label.toLowerCase().includes('session')) {
      // Format as time (assuming value is in seconds)
      const minutes = Math.floor(value / 60);
      const seconds = value % 60;
      return `${minutes}m ${seconds}s`;
    }
    
    // Format as number with commas
    return value.toLocaleString();
  };
  
  return (
    <Card>
      <CardContent className="p-6">
        <div className="flex items-center justify-between">
          <div className="space-y-1">
            <p className="text-sm font-medium text-muted-foreground">{label}</p>
            <p className="text-2xl font-bold">{formatValue(value)}</p>
          </div>
          {icon && (
            <div className="h-12 w-12 rounded-full bg-muted flex items-center justify-center">
              {icon}
            </div>
          )}
        </div>
        <div className="mt-4 flex items-center">
          {trend === 'up' ? (
            <ArrowUpIcon className="mr-1 h-4 w-4 text-green-500" />
          ) : trend === 'down' ? (
            <ArrowDownIcon className="mr-1 h-4 w-4 text-red-500" />
          ) : null}
          <span className={`text-sm font-medium ${
            trend === 'up' ? 'text-green-500' : 
            trend === 'down' ? 'text-red-500' : 
            'text-muted-foreground'
          }`}>
            {change > 0 ? '+' : ''}{change}% from last period
          </span>
        </div>
      </CardContent>
    </Card>
  );
}
